import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import { Button } from '@material-ui/core';
import AWSLogo from '../../assets/images/products/aws.png';
import TerraformLogo from '../../assets/images/products/terraform.svg';


export interface ProductProps {
  title: string;
  description: string;
  price: string;
  gatsbyImageData: IGatsbyImageData;
  slug: string;
}

const useStyles = makeStyles({
  root: {
    height: '100%',
    border: '0.5px solid #d6d6d675',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    borderRadius: 12,
  },
  imageWrapper: {
    display: 'flex',
    padding: '16px 16px 8px',
    position: 'relative',
  },
  logoImage: {
    width: '20%',
    maxWidth: 85,
    minWidth: 15,
    position: 'absolute',
    top: 5,
    right: 5,
  },
  cardTitle: {
    display: '-webkit-box',
    lineHeight: 1.2,
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    marginBottom: 16,
    fontWeight: 'bold',
  },
  cardDescription: {
    color: '#707070',
  },
  cardButton: {
    color: '#4285f6',
    fontWeight: 'bold',
    margin: '0 !important',
    '&:hover': {
      backgroundColor: '#4285f626',
    }
  },
  cardPrice: {
    marginTop: 21,
    marginBottom: 10,
    color: '#707070',
    fontWeight: 'bold',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif !important'
  },
  content: {
    textAlign: 'left',
    paddingBottom: '0 !important',
  },
  cardActions: {
    width: '100%',
    textAlign: 'left',
    padding: '8px 16px',
  },
  price: {
    paddingLeft: 8,
    textAlign: 'left',
  },
  detailsButtonWrapper: {
    width: '100%'
  }
});

const Product = ({ title, description, price, gatsbyImageData, slug }: ProductProps) => {
  const classes = useStyles();
  return (
    <Card className={classes.root} elevation={0}>
      <div>
        <CardMedia className={classes.imageWrapper}>
          {/* <GatsbyImage
            alt={title}
            image={gatsbyImageData}
          /> */}
          <img src={TerraformLogo} alt="Terraform-logo"/>
          <img src={AWSLogo} alt="AWS-logo" className={classes.logoImage}/>
        </CardMedia>
        <CardContent className={classes.content}>
        <Typography variant="h6" className={classes.cardTitle}>{title}</Typography>
          <Typography variant="body1" className={classes.cardDescription}>{description}</Typography>
        </CardContent>
      </div>
      <div className={classes.cardActions}>
        {Number(price) != 0 && (
          <Typography variant="body2" className={classes.cardPrice}>{`$ ${price}`}</Typography>
        )}
        {Number(price) == 0 && (
          <Typography variant="body2" className={classes.cardPrice}>Free</Typography>
        )}
          <Button href={`/products/${slug}`}  className={classes.cardButton} variant="outlined" fullWidth color="inherit">preveiw</Button>
      </div>
    </Card>
  );
};

export default Product;
